import React, { useEffect, useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { SelectContainer } from "commonComponents/FormElement/Select/SelectStyled";
import {
  UPDATED_CAR_DATA_STATE,
  LIST_BY_GLOBAL_STATES,
  MAX_HOLES_GLOBAL_STATE,
  SITEID_GLOBAL_STATE,
  ADMIN_SITE_SETTINGS,
  MAX_VOLUME_ALLOWED,
} from "globalStore/globalStore";
import { useHookstate } from "@hookstate/core";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { PopUpContainer } from "assets/css/globle";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useTranslation } from "react-i18next";
import { useCarSettingsData } from "_helperFunctions/carSettings";

const guardianModeString = {
  normal: "NORMAL",
  staging: "STAGING",
  lockdown: "LOCKDOWN",
};

export default function SelectStyled(props) {
  const { t } = useTranslation();
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const { updatedCarData } = useHookstate(UPDATED_CAR_DATA_STATE);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [open2, setOpen2] = useState(false);
  const handleClose2 = () => setOpen2(false);
  const [releasedCarData, setReleasedCarData] = useState([]);
  const [dropdownData, setDropdownData] = useState(null);
  
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "400px",
    width: "100%",
    bgcolor: "background.paper",
    borderRadius: "5px",
    overflow: "hidden",
  };

  const { maxHolesAllowed, detectChangeMaxHolesAllowed } = useHookstate(
    MAX_HOLES_GLOBAL_STATE
  );

  const { selectedCustomerServiceProfile } = useHookstate(ADMIN_SITE_SETTINGS);

  // Maximum volume allowed Dropdown variable
  const { maxVolumeAllowed, maxVolumeOptionTriggered } =
    useHookstate(MAX_VOLUME_ALLOWED);
  const dispatch = useDispatch();

  const { siteSettingsData } =
    useSelector((state) => state.commonReducers) || [];

  let updatedSiteSettingData = siteSettingsData && siteSettingsData;

  const { listBy, sortBy, modeBy } = useHookstate(LIST_BY_GLOBAL_STATES);
  const { guardianMode } = useCarSettingsData();

  const [carsData, setCarsData] = useState([]);
  const [modeText, setModeText] = useState("");

  useEffect(() => {
    let localCarData =
      !Array.isArray(updatedCarData.get()) &&
      typeof updatedCarData.get() === "string" &&
      JSON.parse(updatedCarData.get());

    let filteredData = [];

    if (
      updatedCarData.get() &&
      Array.isArray(localCarData) &&
      localCarData.length !== 0
    ) {
      setCarsData([...localCarData]);
      let newData = localCarData?.filter(
        (item) =>
          item?.Car?.GuardianCapable !== false && !item?.Car?.AllowedToMove
      );
      filteredData.push(newData);
    }

    setReleasedCarData(filteredData);
  }, [updatedCarData.get()]);

  const handleChange = (event) => {
    if (
      event.target.value === "NONE" ||
      event.target.value === "CHARGING" ||
      event.target.value === "ALERTS" ||
      event.target.value === "IN USE" ||
      event.target.value === "ACTION ZONE" ||
      event.target.value === "STAGED" ||
      event.target.value === "MEMBER CARS" ||
      event.target.value === "ADMIN ONLY"
    ) {
      listBy.set(event.target.value);
      localStorage.setItem("ListBy", event.target.value);
    } else if (
      event.target.value === "0" ||
      event.target.value === "9" ||
      event.target.value === "18"
    ) {
      detectChangeMaxHolesAllowed.set(true);
      maxHolesAllowed.set(event.target.value);
    } else if (
      event.target.value === guardianModeString.normal ||
      event.target.value === guardianModeString.staging ||
      event.target.value === guardianModeString.lockdown
    ) {
      if (event.target.value === guardianModeString.normal) {
        setGuardianMode(guardianMode.normal);
      } else if (event.target.value === guardianModeString.staging) {
        setGuardianMode(guardianMode.staging);
      } else {
        setGuardianMode(guardianMode.lockdown);
      }
      setDropdownData(event.target.value);

      // }
    } else if (event.target.name === "siteSettings") {
      selectedCustomerServiceProfile.set(event.target.value);
    } else if (
      event.target.value === "Mute" ||
      event.target.value === "Low" ||
      event.target.value === "Medium" ||
      event.target.value === "High"
    ) {
      maxVolumeAllowed.set(event.target.value);
      maxVolumeOptionTriggered.set(true);
    } else {
      sortBy.set(event.target.value);
      localStorage.setItem("sortBy", event.target.value);
    }
  };

  const handleModalButtons = (buttonEvent) => {
    if (buttonEvent === "yes") {
      if (dropdownData === guardianModeString.normal) {
        dispatch(
          COMMON_SERVICES.purCarStagingGuardianModeServices({
            ...updatedSiteSettingData,
            GuardianMode: 1,
          }, siteId.get())
        ).then(() => {
          dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
        });

        modeBy.set(guardianModeString.normal);
        localStorage.setItem("mode", guardianModeString.normal);
        handleClose();
      } else if (dropdownData === guardianModeString.staging) {
        dispatch(
          COMMON_SERVICES.purCarStagingGuardianModeServices({
            ...updatedSiteSettingData,
            GuardianMode: 2,
          }, siteId.get())
        ).then(() => {
          dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
        });
        modeBy.set(guardianModeString.staging);
        localStorage.setItem("mode", guardianModeString.staging);
        handleClose();
      } else {
        dispatch(
          COMMON_SERVICES.purCarStagingGuardianModeServices({
            ...updatedSiteSettingData,
            GuardianMode: 3,
          }, siteId.get())
        ).then(() => {
          dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
        });
        modeBy.set(guardianModeString.lockdown);
        localStorage.setItem("mode", guardianModeString.lockdown);
        handleClose();
      }
    } else {
      handleClose();
    }
  };

  function setGuardianMode(mode) {
    let prompt = "";
    // TBD: make this prompt more sophisticated, ala the VCC, based on current car states---new---may create new buttons make more like VCC instead
    if (mode === guardianMode.lockdown) {
      let carsNotOnCharger = carsData?.filter(function (element) {
        return element?.Car?.IsCharging === false;
      });

      if (carsNotOnCharger.length > 0) {
        prompt =
          "There are" +
          " " +
          carsNotOnCharger.length +
          " " +
          "cars not on the charger that will be locked down. Continue to lock down all cars?";
      } else {
        prompt = "Lock down cars?";
      }
    } else if (mode === guardianMode.staging) {
      prompt = t("Enter_staging_mode?");
    } else {
      // changing to Normal mode
      if (siteSettingsData?.GuardianMode === guardianMode.staging) {
        let carsStaged = carsData?.filter(function (element) {
          return !element?.Car?.AllowedToMove;
        });

        if (carsStaged.length > 0) {
          prompt = carsStaged.length + " " + "cars will be released. Continue?";
        } else {
          // No cars are staged, leave prompt blank so it switches without prompting
        }
      } else if (siteSettingsData?.GuardianMode === guardianMode.lockdown) {
        prompt = "Release all cars?";
      }
    }
    setModeText(prompt);
    if (prompt !== "") {
      handleOpen();
    } else {
      dispatch(
        COMMON_SERVICES.purCarStagingGuardianModeServices({
          ...updatedSiteSettingData,
          GuardianMode: mode,
        }, siteId.get())
      ).then(() => {
        dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
      });
    }
  }
  useEffect(() => {
    if (siteId.get()) {
      setModeText("");
    }
  }, [siteId.get()]);

  return (
    <>
      <SelectContainer className="select">
        <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
          <Select
            disabled={props.disabled}
            value={props.value}
            onChange={handleChange}
            displayEmpty
            inputProps={{ "aria-label": "Without label" }}
            IconComponent={KeyboardArrowDownIcon}
            name={props.id}
          >
            {props.data &&
              props.data?.map((d, i) => (
                <MenuItem
                  id={props.id}
                  value={d.value}
                  key={`${d}_${i}`}
                >
                  {d.label}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </SelectContainer>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <h2>Confirm</h2>
            <p style={{ padding: "15px" }}>
              {modeText}
            </p>
            <div className="action-btn" style={{ marginTop: 20 }}>
              <button
                onClick={() => handleModalButtons("yes")}
                className="primary"
              >
                {t("Yes")}
              </button>
              <button onClick={() => handleModalButtons("no")}>
                {t("No")}
              </button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
      <Modal
        open={open2}
        onClose={handleClose2}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <h2>Confirm</h2>
            <p style={{ padding: "15px" }}>
              {releasedCarData.length} cars will be released. Continue?
            </p>
            <div className="action-btn" style={{ marginTop: 20 }}>
              <button
                onClick={() => handleModalButtons("yes")}
                className="primary"
              >
                {t("Yes")}
              </button>
              <button onClick={() => setOpen2(false)}>{t("No")}</button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    </>
  );
}
